<template>
  <teleport to="body">
    <div
      class="indicoo-modal overlay"
      v-if="state.isActive"
      @click="handleModalToggle({ status: false })"
    >
      <div
        class="indicoo-modal__content"
        :style="{ 'max-width': `${state.width}` }"
        @click.stop
      >
        <button
          type="button"
          class="indicoo-modal__close"
          aria-label="Fechar"
          @click="handleModalToggle({ status: false })"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <component
          :is="state.component"
          :options="state.props"
          @closeModal="handleModalToggle({ status: false })"
        />
      </div>
    </div>
  </teleport>
</template>

<script>
/* eslint-disable comma-dangle, indent */
import {
  defineAsyncComponent, onBeforeUnmount, onMounted, reactive, ref
} from 'vue';
import useModal from '../../hooks/useModal';

const DEFAULT_WIDTH = '480px';
const Modal = defineAsyncComponent(() => import('../Elements/Modal.vue'));
const FormLogin = defineAsyncComponent(() => import('../../modules/person/components/Forms/LoginForm.vue'));
const SignUpForm = defineAsyncComponent(() => import('../../modules/person/components/Forms/SignUpForm.vue'));
const JobIndicationModal = defineAsyncComponent(() => import('../../views/Job/JobIndicationModal.vue'));
const CategoryModal = defineAsyncComponent(() => import('../../views/Admin/Categories/CategoryModal.vue'));
const CategoryExclusionModal = defineAsyncComponent(() => import('../../views/Admin/Categories/CategoryExclusionModal.vue'));
const RewardTypeCompanyModal = defineAsyncComponent(() => import('../../views/Admin/RewardTypeCompany/RewardTypeCompanyModal.vue'));
const RewardTypeCompanyExclusionModal = defineAsyncComponent(() => import('../../views/Admin/RewardTypeCompany/RewardTypeCompanyExclusionModal.vue'));

export default {
  components: {
    FormLogin,
    Modal,
    JobIndicationModal,
    SignUpForm,
    CategoryModal,
    CategoryExclusionModal,
    RewardTypeCompanyModal,
    RewardTypeCompanyExclusionModal,
  },
  setup() {
    const modal = useModal();
    const state = reactive({
      isActive: false,
      component: {},
      props: {},
      width: DEFAULT_WIDTH,
      class: '',
    });

    const handleModalToggle = (payload) => {
      if (payload.status) {
        state.component = payload.component;
        state.props = ref(payload.props);
        state.width = payload.width ?? DEFAULT_WIDTH;
        state.class = payload.class ?? '';
      } else {
        state.component = {};
        state.props = {};
        state.width = DEFAULT_WIDTH;
        state.class = '';
      }

      state.isActive = payload.status;
    }

    onMounted(() => {
      modal.listen(handleModalToggle);
    });

    onBeforeUnmount(() => {
      modal.off(handleModalToggle);
    });

    return {
      state,
      handleModalToggle,
    };
  },
};
</script>

<style scoped>
.indicoo-modal {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(6, 13, 26, 0.7);
  backdrop-filter: blur(2px);
  z-index: 999;
  padding: 24px;
}

.indicoo-modal__content {
  position: relative;
  width: 100%;
  max-height: 90vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--navy-card);
  border: 1px solid var(--navy-border);
  border-radius: var(--r-lg);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
  padding: 32px;
}

.indicoo-modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--r-sm);
  background: var(--navy-mid);
  border: 1px solid var(--navy-border);
  color: var(--muted);
  cursor: pointer;
  z-index: 10;
}

.indicoo-modal__close:hover {
  color: var(--white);
  border-color: var(--cyan);
}

.indicoo-modal__close svg {
  width: 16px;
  height: 16px;
}

@media (max-width: 600px) {
  .indicoo-modal {
    padding: 0;
  }

  .indicoo-modal__content {
    max-width: 100% !important;
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    padding: 24px 20px;
  }
}
</style>
